import { Text, Button, Group } from "@mantine/core";

interface ActionBarProps {
  showConvertNotice?: boolean;
}

export function ActionBar({ showConvertNotice }: ActionBarProps) {
  return (
    <Group justify="flex-end" mt="md" bg="gray.1" p="sm">
      {showConvertNotice && (
        <Text fs="italic" c="dimmed" size="sm">
          After submitting, the old request will be deleted.
        </Text>
      )}
      <Button type="submit">Submit</Button>
    </Group>
  );
}